module.exports = __webpack_public_path__ + "static/media/S-WEB-Goal-8.23671e3d.png";